import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import { ModalTemplate, Button, ReduxFormHiddenInput } from 'components';
import { Dropdown, Message, Label } from 'semantic-ui-react';

import { reduxForm } from 'redux-form';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalTagTargetAdd extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      visible,
      isClicked,
      errorMessage,
      tagDataArray,
      addTagNoArray,
      onAddTagTarget,
      onToggleModal,
      handleChangeModalTag,
      handleSearchChange,
      handleBlur,
      searchText
    } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-tagTargetAdd-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalTagTargetAdd_1', defaultMessage: '태그 일괄 추가' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTagTargetAdd_3', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('brand-button')} disabled={isClicked} loading={isClicked} onClick={onAddTagTarget} disabled={!!searchText}>
              {defineMessages(formatMessage({ id: 'ModalTagTargetAdd_2', defaultMessage: '추 가' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <div className={cx('message-header')}>
            {defineMessages(formatMessage({ id: 'ModalTagTargetAdd_4', defaultMessage: '추가할 태그를 선택하세요.' }))}
          </div>
          <Message className={cx('template-detail-box')}>
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'ModalTagTargetAdd_5', defaultMessage: '태그를 입력하세요' }))}
            </span>
            <div className={cx('input-parent')}>
              <Dropdown
                className={cx('tagTarget-dropdown', 'mt-10')}
                // placeholder={defineMessages(formatMessage({ id: 'ModalTagTargetAdd_5', defaultMessage: '태그를 입력하세요' }))}
                name="addTagTarget"
                fluid
                multiple
                error={!!errorMessage}
                search
                selection
                autoFocus
                icon={null}
                options={tagDataArray}
                onChange={handleChangeModalTag}
                renderLabel={(label, index) => ({
                  className: label.data.color,
                  content: label.text
                })}
                onSearchChange={handleSearchChange}
                onBlur={handleBlur}
              />
              <div className={cx('dropdown-arrow')} />
              {!!errorMessage && (
                <Label className={cx('pointing-label')} basic pointing>
                  {errorMessage}
                </Label>
              )}
            </div>
            {/* {errorMessage && <div className={cx('color-red mt-10')}>{errorMessage}</div>} */}
            <ReduxFormHiddenInput name="tagNoArray" />
          </Message>
        </div>
      </ModalTemplate>
    );
  }
}

ModalTagTargetAdd.propTypes = {
  visible: PropTypes.bool,
  onAddTagTarget: PropTypes.func,
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      tagNoArray: props.addTagNoArray
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formTagTargetAdd', enableReinitialize: true })(injectIntl(ModalTagTargetAdd))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalTagTargetAdd.js